import { render, staticRenderFns } from "./ClaimRfidBox.vue?vue&type=template&id=1f2f9e06"
import script from "./ClaimRfidBox.vue?vue&type=script&lang=js"
export * from "./ClaimRfidBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports